import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { AuthShell } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ResetPassword() {
  const { t } = useLang();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset. Please log in.");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title={t("auth.resetTitle")} subtitle="">
      {!token ? (
        <div className="space-y-4">
          <p className="text-muted-foreground">This reset link is missing its token. Please request a new one.</p>
          <Link to="/forgot-password"><Button variant="outline" className="w-full h-12 rounded-xl">{t("auth.forgot")}</Button></Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          <div className="space-y-2">
            <Label htmlFor="password">{t("auth.newPassword")}</Label>
            <Input id="password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="h-12 rounded-xl" data-testid="reset-password" />
          </div>
          <Button type="submit" disabled={loading} className="w-full h-12 rounded-xl bg-secondary hover:bg-secondary/90" data-testid="reset-submit">
            {loading ? t("common.loading") : t("auth.resetBtn")}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
